// @flow

import { CLUSTER_DETAILS_CONFIG } from './cluster-details';

export const CLUSTER_TOP_LEVEL_CONFIG = [...CLUSTER_DETAILS_CONFIG];
